import React from 'react'
import Driver from '../components/Driver/Driver'
import { components } from 'react-select'
import driverbreadcrumbs from "../assets/img/driverbreadcrumbs.jpg";
import Breadcumb from '../components/Breadcumb';
import DownloadArea from '../components/DownloadArea';

const DriverPage = () => {
  return (
    <div>
      <Breadcumb  pageTitle="Drive with CabandGo" backgroundImage={driverbreadcrumbs} />
      <Driver />
      <DownloadArea />
    </div>
  )
}

export default DriverPage
